import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OrderDetail, OrderSummary } from '../models/cart-item';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class OrdersService {



  private baseUrl: string = '/selfcare/orders';

  constructor(private httpClient: HttpClient) { }

  listOrders(): Observable<OrderSummary[]> {
    return this.httpClient.get<OrderSummary[]>(this.baseUrl);
  }

  getOrder(orderId: string): Observable<OrderDetail> {
    return this.httpClient.get<OrderDetail>(this.baseUrl + "/".concat(orderId));
  }

  makePayment(orderId: string, payment: FormData): Observable<OrderDetail> {
    return this.httpClient.post<OrderDetail>(this.baseUrl + "/".concat(orderId).concat('/pay'), payment);
  }

  deleteOrder(orderId: string) {

    return this.httpClient.delete(this.baseUrl + "/".concat(orderId));
}

}
